import 'lazysizes';
import MicroModal from "micromodal";
import Vue from 'vue';

import i18n from './i18n';
import './modules/object-chunk';
import './parallax';
import './animate.init';
import './dropdown';
import './mobile-menu';

try {
  const modalShown = localStorage.getItem('newsletter_modal_shown');
  if (!modalShown) {
    localStorage.setItem('newsletter_modal_shown', 'true');
    MicroModal.show('newsletter_modal');
  }
} catch {
  // Do nothing
}

Vue.mixin(i18n);
Vue.component('ValidationProvider', require('vee-validate').ValidationProvider);
Vue.component('ValidationObserver', require('vee-validate').ValidationObserver);
Vue.component('vue-ctk-date-time-picker', require('vue-ctk-date-time-picker').default);
Vue.component('v-select', require('vue-select').VueSelect);
Vue.component('preloader', require('./components/Preloader').default);

const app = new Vue({
  el: '#app',
  components: {
    'word-rotator': require('./components/WordRotator').default,
    'feedback-form': require('./components/FeedbackForm').default,
    'vehicle-search': require('./components/VehicleSearch').default,
    'vehicle-register': require('./components/VehicleRegister').default,
    'vehicle-toolbar': require('./components/VehicleToolbar').default,
    'locked-info': require('./components/LockedInfo').default,
    'vehicle-edit': require('./components/VehicleEdit').default,
    'vue-form-select': require('./components/VueFormSelect').default,
  }
});
